// 集中管理请求地址，所有的接口地址：

/**
 * title: 接口描述
 * uri: 请求地址
 * method: 请求方式
 * const params = {
    uriCode: 'TEST01',
    // restful
    bindVars: [{
        key: "id",
        value: 'xxx',
    }, {
        key: "type",
        value: 'xxx'
    }]
  }
 */

const API = {
  API001: { title: '注册', uri: '/v1/pub/signup', method: 'post' },
  API002: { title: '登录', uri: '/v1/pub/signin', method: 'post' },
  API003: { title: '获取验证码', uri: '/v1/pub/captcha', method: 'post' },
  API004: { title: '获取用户信息', uri: '/v1/pri/userinfo' },
  API005: { title: '重置密码', uri: '/v1/pub/resetpwd', method: 'post' },
  API006: { title: '获取区块链环境列表', uri: '/v1/pub/chainenv' },
  API007: { title: '根据区块链环境，获取任务列表', uri: '/v1/pub/chaintask' },
  API008: { title: '获取区块链任务详情', uri: '/v1/pub/chaintask/:id' },
  API009: { title: '根据区块链环境，获取工具列表', uri: '/v1/pub/chaintool' },
  API010: { title: '用户登出', uri: '/v1/pri/signout', method: 'post' },
  API011: { title: '获取区块链环境详情', uri: '/v1/pub/chainenv/:id' },
  API012: { title: '根据区块链环境，获取属性列表', uri: '/v1/pub/chainenv_attr' },
  API013: { title: '激活接口', uri: '/v1/pri/activation_code/activate', method: 'post' },
  API014: { title: '保存客户联系方式', uri: '/v1/pub/saveCustomer', method: 'post' },
  API015: { title: '获取环境权限', uri: '/v1/pri/activation_code/userLimits' },
  API016: { title: '获取以太币', uri: '/v1/pub/ethfaucet', method: 'post' },
  API017: { title: '获取区块链环境总任务数量列表', uri: '/v1/pub/chainenvcount' },
  API018: { title: '根据区块链环境，获取文档列表', uri: '/v1/pub/chaindocument' },
  API019: { title: '根据区块链环境，获取资源列表', uri: '/v1/pub/resource', method: 'post' },
  API020: { title: '根据环境查询案例列表', uri: '/v1/pub/chain_env_example/list' },
  API021: { title: '根据案例ID查询案例详情', uri: '/v1/pub/chain_env_example' },
  API022: { title: '获取项目详情', uri: '/v1/pri/training/project' },
  API023: { title: '修改项目信息', uri: '/v1/pri/training/project', method: 'put' },
  API024: { title: '新增项目信息', uri: '/v1/pri/training/project', method: 'post' },
  API025: { title: '删除项目信息', uri: '/v1/pri/training/project', method: 'delete' },
  API026: { title: '获取项目列表', uri: '/v1/pri/training/project/list' },
  API027: { title: '生成邀请链接', uri: '/v1/pri/training/project/invite' },
  API028: { title: '加入邀请链接', uri: '/v1/pri/training/project/join', method: 'post' },
  API029: { title: '获取项目成员', uri: '/v1/pri/training/project/members' },
  API030: { title: '修改项目成员职位', uri: '/v1/pri/training/project/member', method: 'put' },
  API031: { title: '移除项目成员', uri: '/v1/pri/training/project/member', method: 'delete' },
  API032: { title: '获取里程碑列表', uri: '/v1/pri/training/project/progress' },
  API033: { title: '添加里程碑', uri: '/v1/pri/training/project/progress', method: 'post' },
  API034: { title: '修改里程碑', uri: '/v1/pri/training/project/progress', method: 'put' },
  API035: { title: '删除里程碑', uri: '/v1/pri/training/project/progress', method: 'delete' },
  API036: { title: '获取日志列表', uri: '/v1/pri/training/project/logger' },
  API037: { title: '添加日志', uri: '/v1/pri/training/project/logger', method: 'post' },
  API038: { title: '修改日志', uri: '/v1/pri/training/project/logger', method: 'put' },
  API039: { title: '删除日志', uri: '/v1/pri/training/project/logger', method: 'delete' },
  API040: { title: '新建项目仓库', uri: '/v1/pri/training/project/repository', method: 'post' },
  API041: { title: '获取仓库地址', uri: '/v1/pri/training/project/repository' },
  API042: { title: '获取图形验证码', uri: '/v1/pub/captcha/real' },
  API043: { title: '新增实战任务', uri: '/v1/pub/chaintask', method: 'post' },
  API044: { title: '删除实战任务', uri: '/v1/pub/chaintask', restful: true, method: 'put' },
  API045: { title: '删除实战任务', uri: '/v1/pub/chaintask', restful: true, method: 'delete' }
}

const ZP_API = {
  ZP_API001: { title: '模板库列表', uri: '/v1/pri/training/project/template' },
  ZP_API002: { title: '将项目设置为个人模版库', uri: '/v1/pri/training/project/setTemplate', method: 'post' },
  ZP_API003: { title: '删除项目模版', uri: '/v1/pri/training/project/deleteTemplate', method: 'post' },
  ZP_API004: { title: '项目模版快速新建项目', uri: '/v1/pri/training/project/genProject', method: 'post' },
  ZP_API005: { title: '搜索用户', uri: '/v1/pri/training/project/searchUser' },
  ZP_API006: { title: '实战营添加成员', uri: '/v1/pri/training/project/addUser', method: 'post' },
  ZP_API007: { title: '里程碑关联任务', uri: '/v1/pri/training/project/joinTask', method: 'post' },
  ZP_API008: { title: '里程碑下的任务', uri: '/v1/pri/training/project/milestoneTask' },
  ZP_API009: { title: '模版详情', uri: '/v1/pri/training/project/milestoneDetail' },
  ZP_API0010: { title: '项目是否有私有任务', uri: '/v1/pri/training/project/isPrivateTask' },
  ZP_API0011: { title: '获取所有任务列表（自己私有的加公开的）', uri: '/v1/pub/chaintask/list' }
}

const API_PUB = {
  API_PUB001: { title: '获取系统配置', uri: '/v1/getConfig' },
  API_PUB002: { title: '获取oss的token', uri: '/v1/pri/oss/token' }
}

export default {
  ...API,
  ...API_PUB,
  ...ZP_API
}
